// TEMPORARY: Heap's `_hp5_*` cookies are set on `.greyscout.com` and ride along on every
// same-domain API request, bloating the Cookie header until the proxy rejects it
// ("headers too long" / HTTP 431). This wipes the persisted ones at cold start, before the
// first API call, so a fresh page load doesn't carry last session's analytics cookies.
//
// Scope caveat: because the cookies live on `.greyscout.com`, the delete must be issued for
// that same domain (and the host, and no-domain) to take effect. HttpOnly cookies
// (`IdToken`, `BearerToken`, `Oauth*`, `cf_clearance`) are invisible to JS and left untouched.
//
// This is a stopgap. Heap's SDK (loaded later by useHeapLoader, gated by the
// `isAnalyticsTrackingEnabled` flag) re-creates these cookies once tracking is enabled, so the
// durable fix is to scope Heap's cookies off the API host (or disable the flag). Remove then.
const PREFIXES = ['_hp5']; // _hp5_meta.*, _hp5_let.*, _hp5_event_props.*

const clearCookiesByPrefix = (prefixes: string[]) => {
  const host = location.hostname;
  const parts = host.split('.');

  // Candidate domains the cookie may be scoped to: none (host-only), the exact host, and every
  // parent registrable domain (e.g. `.greyscout.com`). A delete only lands when domain + path match.
  const domains: (string | null)[] = [null, host];
  for (let i = 0; i < parts.length - 1; i++) {
    domains.push('.' + parts.slice(i).join('.'));
  }

  const names = (document.cookie ? document.cookie.split('; ') : [])
    .map((cookie) => cookie.split('=')[0])
    .filter((name) => name && prefixes.some((prefix) => name.startsWith(prefix)));

  for (const name of names) {
    for (const domain of domains) {
      document.cookie =
        `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/` +
        (domain ? `; domain=${domain}` : '');
    }
  }
};

clearCookiesByPrefix(PREFIXES);
